import React from 'react'
import { Button, ButtonToolbar } from 'react-bootstrap'
import { find, last } from 'lodash'
import { NotificationManager } from 'react-notifications'

import Topbar from '../Topbar'
import IconTooltip from '../../components/IconTooltip'
import Question from '../../components/Question'
import Collaboration from '../../components/Collaboration'
import {buildAnswerMap, isEmptyValue} from '../../utils'
import EmailModal from '../../components/EmailModal'
import ConfirmScanModal from './modal/index'

import * as scansService from '../../services/scan-service'
import * as questionService from '../../services/question-service'
import * as answerService from '../../services/answer-service'

import { CollaboratorsContext } from '../../context/CollaboratorsContext'
import { EmailContext } from '../../context/EmailContext'


import '../../components/react-bootstrap-switch.min.css'

export default class CoreQuestions extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleChange = this.handleChange.bind(this)
    this.completeScan = this.completeScan.bind(this)
    this.isQuestionAnswered = this.isQuestionAnswered.bind(this)
    this.sendEmailCheck = this.sendEmailCheck.bind(this)
    this.sendEmail = this.sendEmail.bind(this)
    this.backToScans = this.backToScans.bind(this)
    this.completeScanPrecheck = this.completeScanPrecheck.bind(this)
    this.state = {
      scan: {},
      questions: { coreQuestions: [], extraQuestions: [] },
      answers: [],
      location: undefined,
      unit: undefined,
      disabledEmailButton: false
    }
  }

  componentWillMount() {
    this.getData(this.props.match.params.scanId)
  }

  getData(scanId) {
    Promise.all([
      scansService.getScanById(scanId),
      answerService.getAnswers(scanId),
      questionService.getQuestion(1, scanId),
    ])
        .then(([scan, answers, questions]) => {
          this.setState({
            ...this.state,
            scan,
            answers,
            questions,
            scanId,
            location: scan.locationName,
            unit: scan.organizationalUnitName,
          })

          const commentsFromStorage = localStorage.getItem("comments")
          if (commentsFromStorage) {
            const commentsArray = JSON.parse(commentsFromStorage)
            const commentPromises = commentsArray.map((comment) =>
                answerService.updateAnswer({
                  scanId: scanId,
                  questionId: comment.questionId,
                  comment: comment.comment,
                })
            )

            Promise.all(commentPromises)
                .then(() => {
                  localStorage.removeItem("comments")
                })
                .catch((error) => {
                  console.error("Error uploading comments:", error)
                })
          }
        })
        .catch((error) => {
          console.error("Error loading data:", error)
        })
  }


  completeScanPrecheck() {
    this.completescan.handleShow()
  }

  sendEmail() {
    scansService.sendemail(this.state.scanId).then(response => {
      this.setState({ status: 'OK', response: response, message: "De email is verzonden", disabledEmailButton: true })
      this.sendemailcheck.handleHide()
      NotificationManager.success(this.state.message)
    }).catch((error) => {
      this.setState({ status: 'ERROR', message: "Email is niet verzonden", disabledEmailButton: false })
      this.sendemailcheck.handleHide()
      NotificationManager.error(this.state.message)
    })
  }

  sendEmailCheck() {
    this.sendemailcheck.handleShow()
  }

  backToScans() {
    this.props.history.push(`/scans`)
  }

  completeScan() {
    scansService.completeScan(this.state.scanId).then(() => {
      this.props.history.push(`/results/${this.state.scanId}`)
    })
  }

  handleChange(e, values, save) {
    let answers = this.state.answers
    let scanId = this.state.scanId
    let type = e.target.type

    let promises = []
    if (type === 'radio') {
      const optionId = parseInt(e.target.value, 10)

      // Update all others too
      for (let i = 0; i < values.length; i++) {
        const booleanValue = values[i] === optionId

        promises.push(answerService.upsertAnswer({ scanId, optionId: values[i], booleanValue }))

        let answer = find(answers, a => a.optionId === values[i])
        if (!answer) {
          answer = { scanId, optionId: values[i] }
          answers.push(answer)
        }
        answer.booleanValue = booleanValue
      }
    } else if (type === 'checkbox') {
      const optionId = parseInt(e.target.value, 10)
      const booleanValue = e.target.checked

      promises.push(answerService.upsertAnswer({ scanId, optionId, booleanValue }))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = { scanId, optionId }
        answers.push(answer)
      }

      const lastOptionId = last(values)
      if (lastOptionId === optionId) {
        const rest = values.slice(0, -1)

        for (let i = 0; i < rest.length; i++) {
          promises.push(answerService.upsertAnswer({ scanId, optionId: rest[i], booleanValue: false }))

          let restAnswer = find(answers, a => a.optionId === rest[i])

          if (!restAnswer) {
            restAnswer = { scanId, optionId: rest[i] }
            answers.push(restAnswer)
          }
          restAnswer.booleanValue = false
        }
      } else {
        promises.push(answerService.upsertAnswer({ scanId, optionId: lastOptionId, booleanValue: false }))

        let lastAnswer = find(answers, a => a.optionId === lastOptionId)
        if (!lastAnswer) {
          lastAnswer = { scanId, optionId, booleanValue: false }
          answers.push(lastAnswer)
        }
        lastAnswer.booleanValue = false
      }
      answer.booleanValue = booleanValue
    } else if (type === 'select-one') {
      const optionId = parseInt(e.target.name, 10)

      promises.push(answerService.upsertAnswer({ scanId, optionId, stringValue: e.target.value }))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = { scanId, optionId }
        answers.push(answer)
      }

      answer.stringValue = e.target.value
    } else {
      const optionId = values
      promises.push(answerService.upsertAnswer({ scanId, optionId, stringValue: e.target.value }))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = { scanId, optionId }
        answers.push(answer)
      }
      answer.stringValue = e.target.value
    }

    if (save) {
      Promise.all(promises).then(() => this.setState({ answers }))
    } else {
      this.setState({ answers })
    }
  }

  validate() {
    const { questions, answers } = this.state
    const { coreQuestions } = questions

    let allAnswered = true
    coreQuestions.forEach(coreQuestionGroup => {
      coreQuestionGroup.questions.forEach(q => {
        allAnswered &= this.isQuestionAnswered(q, answers)
      })
    })

    return allAnswered
  }

  isQuestionAnswered(q, answers) {
    let questionHasAnswer = false

    if (q.optionType === 'RADIO' || q.optionType === 'CHECKBOX') {
      // vraag is beantwoord als er minimaal 1 optie is aangevinkt
      questionHasAnswer = false
      q.options.forEach(option => {
        const answersFiltered = answers.filter(a =>
          a.optionId === option.id && a.booleanValue)
        questionHasAnswer |= answersFiltered.length > 0
      })
    } else {
      // vraag is beantwoord als alle opties een waarde hebben
      // Dit geld voor 'SELECT' en andere type vragen
      questionHasAnswer = true
      q.options.forEach(option => {
        const answersFiltered = answers.filter(a =>
          a.optionId === option.id && !isEmptyValue(a.stringValue) && Number(a.stringValue) >= option.minValue && Number(a.stringValue) <= q.questionMaxValue)
        questionHasAnswer &= answersFiltered.length > 0
      })
    }

    return questionHasAnswer
  }

  getCoreQuestions(coreQuestions, answers, completed, questions) {
    return (
      <div className="scan-container">
        {coreQuestions.map((core, index) => (
          <div className="scan-section" key={index}>
            <div className="header-section row">
              <div className="col">
                <h2>
                  Fase {index + 1}: {core.headerText} {<IconTooltip id={core.headerText} icon="far fa-info-circle" />}
                </h2>
              </div>
              <div className="col consultation-header">
                <span>Raadplegen medewerker <IconTooltip id={core.headerText} icon="far fa-info-circle" /></span>
              </div>
            </div>

            {core.questions.map((question, i) => (
              <Question
                key={i}
                question={question}
                onChange={this.handleChange}
                state={answers}
                completed={completed}
                answermap={buildAnswerMap(questions, answers)}
              />
            ))}
          </div>
        ))}
      </div>
    )
  }

  getExtraQuestions(extraQuestions, answers, completed, questions, collaborators) {
    return (
      <div className="scan-container open-text">
        <div className="scan-section">
          <div className="header-section row">
            <div className="col">
              <h2>Extra vragen medewerkers <IconTooltip
                text="<p>Om ook rekening te houden met de mate waarin beleid daadwerkelijk op de zorgafdelingen het veronderstelde effect heeft, kunt u vijf extra vragen aan medewerkers voorleggen. De uitkomsten ervan tellen niet mee in de scores van de scan, maar geven u wel meer inzicht in wat medewerkers in de praktijk van het beleid merken.</p><p>De extra vragen die aan medewerkers gesteld worden zijn:</p><ul><li>Hoe groot schat u de kans dat er brand ontstaat?</li><li>Hoeveel aandacht is er voor brandveiligheid?</li><li>Wordt er regelmatig geoefend op ontruimen?</li><li>Zijn er afspraken gemaakt over brandveiligheid?</li><li>Is er verder nog iets dat u kwijt wilt over de brandveiligheid?</li></ul><p>Inhoudelijk ligt het accent iets meer op gedrags- en cultuurgerelateerde factoren en minder op de technische en aan het gebouw gerelateerde aspecten die in de voorgaande vragen al aan bod kwamen.</p>"
                icon="far fa-info-circle" />
              </h2>
            </div>

            <div className="col consultation-header">
              <span>Raadplegen medewerker <IconTooltip text="<p>Raadplegen medewerker</p>"
                icon="far fa-info-circle" /></span>
            </div>
          </div>

          <div className="question-group row">
            <div className="col">
              <span>U kunt vijf extra vragen aan medewerkers voorleggen om inzicht te krijgen in wat medewerkers in de praktijk merken van het brandveiligheidsbeleid. Deze extra vragen worden meegestuurd met eventuele raadplegingen aan de medewerkers. Indien u dit wilt, zet u het schuifje hiernaast naar rechts.</span>
            </div>
            {extraQuestions.map((extra, index) => {
              //this trick ensures that the mutation will render the component
              return (index < 1) ?
                (<Collaboration data={extraQuestions}
                  key={index}
                  answermap={null}
                  collaborators={collaborators}
                  scanId={this.props.match.params.scanId}
                  isExtraQuestion={true}
                />)
                : null
            })}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { answers, scan, questions, location, unit } = this.state
    const { coreQuestions, extraQuestions } = questions
    const completed = !!scan.completedDate

    return (
      <CollaboratorsContext.Consumer>
        {ctx => {
          if (ctx.state.scanId !== this.props.match.params.scanId) {
            window.sessionStorage.setItem('scanId', this.props.match.params.scanId)
            ctx.updateScan()
          }
          return (
            <div className="content col-2 scans">
              <div className="content-inner">
                <Topbar
                  title="ScDan"
                  select={true}
                  location={location}
                  unit={unit}
                  disabled={true}
                />

                <div className="inner">
                  {this.getCoreQuestions(coreQuestions, answers, completed, questions)}

                  {this.getExtraQuestions(extraQuestions, answers, completed, questions, ctx.state.collaborators)}
                </div>

                {!completed && (
                  <div id="action-buttons">
                    <ButtonToolbar>
                      <Button bsStyle="primary" className="view-entry action-btn" disabled={!this.validate()}
                        onClick={this.completeScanPrecheck}>
                        Voltooien
                      </Button>
                      <Button onClick={this.backToScans}>Afsluiten</Button>
                      <EmailContext.Consumer>
                        {context => {
                          /*
                           When loading the scan, disable the collaboration for the previous scans with feedback already processed
                           */
                          if (this.state.scan) {
                            const scan = this.state.scan
                            const checkIfValidDate = (a) => {
                              //Validates if the given string is a number, ignoring nulls or undefined values
                              return !isNaN(Date.parse(a))
                            }
                            if (checkIfValidDate(scan.consultationDate) || checkIfValidDate(scan.completedDate)) {
                              if (!context.state.isFeedbackSent) {
                                context.isFeedbackAlreadySent()
                              }
                            } else {
                              return (<Button bsStyle="primary"
                                className="view-entry action-btn"
                                disabled={!context.state.shallActivateEmailButton || this.state.disabledEmailButton}
                                onClick={this.sendEmailCheck}>Vragen versturen</Button>)
                            }
                          }
                        }}
                      </EmailContext.Consumer>
                    </ButtonToolbar>
                  </div>
                )}

                {completed && (
                  <EmailContext.Consumer>
                    {context => {
                      /*
                       When loading the completed scan, disable the collaboration
                       */
                      if (!context.state.isFeedbackSent) {
                        context.isFeedbackAlreadySent()
                      }
                    }}
                  </EmailContext.Consumer>
                )}

                <ConfirmScanModal
                  completeScan={this.completeScan}
                  ref={ref => (this.completescan = ref)}
                />

                <EmailModal
                  mail={this.sendEmail}
                  sendemailcheck={this.sendEmailCheck}
                  ref={ref => (this.sendemailcheck = ref)}
                />
              </div>
            </div>
          )
        }
        }
      </CollaboratorsContext.Consumer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Scan/CoreQuestions.js